import { FeedstockBmpCurveItem } from '../../project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-curve.model';

export interface ProjectInputItemInterface {
  id: string;
  nameElements: string[];
  path: string[];
  value: number;
  unit: string;
  curve: FeedstockBmpCurveItem[];
}

export class ProjectInputItem {
  id: string;
  nameElements: string[];
  path: string[];
  value: number;
  unit: string;
  curve: FeedstockBmpCurveItem[];

  constructor(param: ProjectInputItemInterface = {
    id: '',
    nameElements: [],
    path: [],
    value: undefined,
    unit: '',
    curve: [],
  }) {
    this.id = param.id;
    this.nameElements = param.nameElements;
    this.path = param.path;
    this.unit = param.unit;
  }
}
